import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//Servicios
import {  UserService } from '../../../shared/_services/user.service';
import {   UtilitiesService } from '../../../shared/_services/utilities.service';
import { OfficeService } from '../../../shared/_services/office.service';
//Modelos
import {  User } from '../../../shared/models/user.model';
import { UserRoles } from '../../../shared/models/roles.model';
import { Office } from '../../../shared/models/missingdata.model';
import 'rxjs/Rx';

import { AlertComponent } from '../../../shared/components/alert/alert.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.css']
})
export class NewUserComponent implements OnInit {

  userForm: FormGroup;

  NewUser: User;
  ListRoles: UserRoles[];
  officesList: Office[];

  confirmNewPassword: any;
  error: any;
  passvalid = true;

  showAgentKey: boolean = false;

  idOfficeSelected: number = -1;
  idRoleSelected: number = -1;

  @Output() usuario: EventEmitter<User> = new EventEmitter();
  @Output() collapse: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private _userService: UserService,
    private _utilitiesService: UtilitiesService,
    private officeService: OfficeService
  ) {   
    //Inicializo un Usuario
    this.NewUser = new User();
    //Carga la Lista de Roles    
    this.ListRoles = this._utilitiesService.currentListUserRoles;
  }

  get f() { return this.userForm.controls; }

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      userName: [''],
      userNickName: [''],
      userMail: [''],
      fkUserRole: [''],
      fkUserOffice: [''],
      userPassword: [''],
      confirmPassword: [''],
      agentkey: ['']
    });

    this.f.fkUserRole.valueChanges
      .subscribe(res => {
        this.NewUser.fkIdOffice = undefined;
        this.NewUser.fkAgentKey = undefined;
        if (this.f.fkUserRole.dirty && this.f.fkUserRole.value == 5) {
          this.officeService.getOffices()
            .subscribe(offices => this.officesList = offices);
        } else {
          this.officesList = null;
        }

        if (this.f.fkUserRole.dirty && this.f.fkUserRole.value == 6) {
          this.showAgentKey = true;
        }
      });

  }

  comprobarGuardar() {
    const modalRef = this.modalService.open(AlertComponent, { centered: true });
    modalRef.componentInstance.title = "Usuario Creado";
    modalRef.componentInstance.mensaje = "Se ha creado un nuevo usuario ";
  }

  guardarNewUser() {
    //Valida datos
    if (this.onBlurMethod()) {
      this.NewUser.fkUserRole = this.idRoleSelected;
      if (this.idRoleSelected == 5) {
        this.NewUser.fkIdOffice = this.idOfficeSelected;
      }
      //Guarda los datos
      this._userService.addUser(this.NewUser)
        .subscribe((Usuario: User) => {
          //Ejecuta Metodo del AdminUserComponent
          this.comprobarGuardar();
          this.usuario.emit(Usuario);
        },
        (error: any) => {
          //console.log(error)
          this.error = error;
          this.cleanError();
          return false;
        }
      )
    } else {     
      return false;
    };
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

  onBlurMethod() {
    //valida contraseñas iguales
    if (this.NewUser.userPassword == this.confirmNewPassword && this.NewUser.userPassword != '') {
      this.passvalid = true;
      this.error = null;
      return true;
    } else {
      this.passvalid = false;
      this.confirmNewPassword = '';
      this.error = "Contraseña Incorrecta"
      return false;
    }
  }

  Close(){
    this.NewUser = new User();
    this.collapse.emit(false);
  }


}
